import React, { useCallback, useEffect, useState } from 'react';
import L from 'leaflet';

import useSupercluster from 'use-supercluster';
import { Marker, useMap, Popup } from 'react-leaflet';
import ReactDOMServer from 'react-dom/server';
import { IconButton, Link, Rating, SwipeableDrawer } from '@mui/material';
import { convertToSlug } from 'common/utils';
import VoteNumber from 'components/vote-number';
import MapTicketCard from '../map-ticket-card';
import { WidgetDrawerStyled } from '../hotel-list-map/index.styles';
// import { Cancel } from '@mui/icons-material';

import { routesPaths } from 'config/routes';
import i18n from 'assets/i18n';
import { Cancel } from '@mui/icons-material';
import CurrencyPrice from 'components/currency-price';
import { t } from 'i18next';

interface ShowCrimesProps {
    data: any[];
    mapRef: any;
    isMobile?: boolean;
    params?: any;
    marker?: any;
}

const HotelGroupPin: React.FC<ShowCrimesProps> = ({ data, isMobile, params, marker }) => {
    const map = useMap();
    const maxZoom = 22;
    const [drawer, setDrawer] = useState('');
    const [animation, setAnimation] = useState<any>();

    const [bounds, setBounds] = useState<any>(null);
    const [zoom, setZoom] = useState<number>(12);

    let parameter: string = '';

    if (params) {
        parameter = `checkInDate=${params.start_date}&checkOutDate=${params.end_date}&guest=${params.adults}`;
        if (params.children.length > 0) {
            parameter += `&child=${params.children.join(',')}`;
        }
    }
    const generateUrl = (data: any) => {
        let resultData: string = `${routesPaths[i18n.language].hotelDetails}/${convertToSlug(data.title)}-F${
            data.id
        }?${parameter}`;

        resultData += `&shopId=${data.shopping_file_id}`;

        return resultData;
    };

    // const pinIcon = new L.Icon({
    //     iconUrl: '/assets/images/map-location-group.svg',
    //     iconSize: [24, 24],
    // });

    const icons: { [key: number]: L.DivIcon } = {};
    const fetchIcon = (count: number, size: number): L.DivIcon => {
        if (!icons[count]) {
            const htmlString = ReactDOMServer.renderToStaticMarkup(
                <div
                    className="cluster-marker"
                    style={{
                        transform: `scale(1.${size})`,
                    }}
                >
                    <span className="badge">{count}</span>
                </div>
            );
            icons[count] = L.divIcon({
                html: htmlString,
            });
        }
        return icons[count];
    };
    const pinIcon = (data: any): L.DivIcon => {
        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div className={`cluster-pin-marker ${data.id == animation ? 'active-marker' : ''}`}>
                <CurrencyPrice
                    noCalculate={true}
                    price={data.now_price}
                    fontSize={12}
                    symbol={data.price_currency}
                    fontWeight={true}
                />
            </div>
        );
        data = L.divIcon({
            html: htmlString,
        });
        return data;
    };

    // get map bounds
    const updateMap = () => {
        const b = map.getBounds();
        setBounds([b.getSouthWest().lng, b.getSouthWest().lat, b.getNorthEast().lng, b.getNorthEast().lat]);
        setZoom(map.getZoom());
    };

    const onMove = useCallback(() => {
        updateMap();
    }, [map]);

    useEffect(() => {
        updateMap();
    }, [map]);
    useEffect(() => {
        setAnimation(marker?.id || '');
    }, [marker]);

    useEffect(() => {
        map.on('move', onMove);
        return () => {
            map.off('move', onMove);
        };
    }, [map, onMove]);

    const points = data.map((crime) => ({
        type: 'Feature',
        properties: {
            cluster: false,
            ...crime,
        },
        geometry: {
            type: 'Point',
            coordinates: [crime.longitude, crime.latitude],
        },
    }));

    const { clusters, supercluster } = useSupercluster({
        points: points,
        bounds: bounds,
        zoom: zoom,
        options: { radius: 75, maxZoom: 17 },
    });

    return (
        <>
            {clusters.map((cluster: any) => {
                const [longitude, latitude] = cluster.geometry.coordinates;

                const { cluster: isCluster, point_count: pointCount } = cluster.properties;

                if (isCluster) {
                    return (
                        <Marker
                            key={`cluster-${cluster.id}`}
                            position={[latitude, longitude]}
                            icon={fetchIcon(pointCount, String(pointCount).length * 2)}
                            eventHandlers={{
                                click: () => {
                                    const expansionZoom = Math.min(
                                        supercluster.getClusterExpansionZoom(cluster.id),
                                        maxZoom
                                    );
                                    map.setView([latitude, longitude], expansionZoom, {
                                        animate: true,
                                    });
                                },
                            }}
                        ></Marker>
                    );
                }

                return (
                    <>
                        <Marker
                            key={`crime-${cluster.properties.id}`}
                            position={[latitude, longitude]}
                            icon={pinIcon(cluster.properties)}
                            eventHandlers={{
                                click: () => {
                                    if (isMobile) {
                                        setDrawer('mapInfo-' + cluster.properties.id);
                                    }
                                    setAnimation('');
                                },
                            }}
                        >
                            {!isMobile && (
                                <>
                                    <Popup className="custom-box" autoPan={false}>
                                        <Link
                                            href={generateUrl(cluster.properties)}
                                            underline="none"
                                            color="inherit"
                                            target="_blank"
                                            // data-price={`${NumberFormatInt(cluster.properties.now_price)} ₺`}
                                        >
                                            <div className="column-2">
                                                <div className="ticket-title">{cluster.properties.title}</div>
                                            </div>
                                            <div className="rate-point">
                                                <Rating
                                                    className="ticket-rating"
                                                    max={Math.floor(cluster.properties.rating)}
                                                    name="read-only"
                                                    size="small"
                                                    value={cluster.properties.rating}
                                                    readOnly
                                                />
                                                <VoteNumber
                                                    vote={cluster.properties.vote}
                                                    color="secondary"
                                                    size="small"
                                                    voteAlign="left"
                                                />
                                            </div>
                                            <div className="column-3">
                                                <div className="bottom-box">
                                                    <div className="left">
                                                        <div className="price-box">
                                                            <div className="guest-info">
                                                                {/* <span style={{ whiteSpace: 'nowrap' }}>
                                                                    {moment(params.end_date).diff(
                                                                        moment(params.start_date),
                                                                        'days'
                                                                    )}{' '}
                                                                    Gece,
                                                                </span>{' '} */}
                                                                <span style={{ whiteSpace: 'nowrap' }}>
                                                                    {params.adults}{' '}
                                                                    {t(
                                                                        'hotel.widgets.map.mapTicketCard.passengerText.ADT'
                                                                    )}
                                                                </span>
                                                                <span style={{ whiteSpace: 'nowrap' }}>
                                                                    {params.children.length > 0
                                                                        ? ', ' +
                                                                          params.children.length +
                                                                          ' ' +
                                                                          t(
                                                                              'hotel.widgets.map.mapTicketCard.passengerText.CHD'
                                                                          )
                                                                        : ''}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="price-box">
                                                            {cluster.properties.discount > 0 && (
                                                                <div className="old-price">
                                                                    <CurrencyPrice
                                                                        price={cluster.properties.discount_price}
                                                                        symbol={cluster.properties.price_currency}
                                                                        fontSize={12}
                                                                        line={true}
                                                                        fontWeight={true}
                                                                        noCalculate={true}
                                                                        color="#d32f2f"
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="price-box">
                                                            <div className="ticket-price">
                                                                <CurrencyPrice
                                                                    price={cluster.properties.now_price}
                                                                    fontSize={16}
                                                                    symbol={cluster.properties.price_currency}
                                                                    noCalculate={true}
                                                                    fontWeight={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="right">
                                                        {cluster.properties.cancellable && (
                                                            <div className="text">
                                                                {t('hotel.widgets.map.mapTicketCard.freeCancel')}
                                                            </div>
                                                        )}
                                                        {/* <div className="text">Ön Ödemeye Gerek Yok</div>
                                                        <div className="text">Kredi Kartı Gerekmiyor</div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </Popup>
                                </>
                            )}
                        </Marker>

                        <SwipeableDrawer
                            anchor={'bottom'}
                            open={drawer === 'mapInfo-' + cluster.properties.id}
                            onClose={() => {
                                setDrawer('');
                            }}
                            onOpen={() => setDrawer('mapInfo-' + cluster.properties.id)}
                            disableSwipeToOpen={false}
                            PaperProps={{
                                style: {
                                    borderTopLeftRadius: 12,
                                    borderTopRightRadius: 12,
                                    maxHeight: 'calc(100% - 220px)',
                                },
                            }}
                        >
                            <WidgetDrawerStyled>
                                <IconButton onClick={() => setDrawer('')} className="close">
                                    <Cancel fontSize="inherit" color="disabled" />
                                </IconButton>
                                <MapTicketCard data={cluster.properties} />
                            </WidgetDrawerStyled>
                        </SwipeableDrawer>
                    </>
                );
            })}
        </>
    );
};

export default HotelGroupPin;
